import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    userDetails: {},
  },
  reducers: {
    setUserDetails: (state, action) => {      
      state.userDetails = action.payload;
    },
    clearUserDetails: (state, action) => {
      state.userDetails = {};
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserDetails, clearUserDetails } = userSlice.actions;

export default userSlice.reducer;
